<template>
  <div class="h-dialogContainer-dp">
    <div class='dp-left-width'>
      <ServerDetailLeft :detailShowList="detailShowList" :showAll="false" :detailInfo="detailInfo"></ServerDetailLeft>
    </div>
    <div class='dp-right-width'>
      <ejs-tab ref='deployedTab'>
        <div class="e-tab-header h-subscriber-subTabs-header">
          <div v-for="item of headers" :key="item.key">{{item.text}}</div>
        </div>
        <div class="e-content">
          <!--<div id='deployed'>-->
            <ejs-treegrid :dataSource="data" :treeColumnIndex='index' :allowSorting='true'  childMapping='children' height="430px">
              <e-columns>
                <e-column field='name' headerText='服务&进程ID' textAlign='Left' minwidth="300" width="25%" clipMode="EllipsisWithTooltip"></e-column>
                <e-column field='status' headerText='运行状态' textAlign='Left' minwidth=120 clipMode="EllipsisWithTooltip"></e-column>
                <e-column field='message' headerText='安装结果' textAlign='Left' minwidth=120 clipMode="EllipsisWithTooltip"></e-column>
                <e-column field='cpuUsage' headerText='CPU使用' textAlign='Left' minwidth=70 clipMode="EllipsisWithTooltip"></e-column>
                <e-column field='memoryUsage' headerText='内存使用' textAlign='Left' minwidth=70 clipMode="EllipsisWithTooltip"></e-column>
                <!--<e-column field='createTime' headerText='更新时间' textAlign='Left' width=180 type="date" format='yyyy-MM-dd HH:mm:ss'></e-column>-->
              </e-columns>
            </ejs-treegrid>
          <!--</div>-->
        </div>
      </ejs-tab>
    </div>
  </div>
</template>

<script>
import ServerDetailLeft from '../ServerDetailLeft';

export default {
  name: 'DeployedDetailDialog',
  components: {
    ServerDetailLeft
  },
  data() {
    return {
      headers: [
        { text: this.$t('DeployManagement.deployedTab'), iconCss: 'tabsClass', key: 'deployed' }
      ],
      index: 0,
      deployFlag: false,
      data: [],
      // data: [{
      //   name: 'TEST',
      //   productType: 'TEST',
      //   status: 1,
      //   currentVersion: 'V3.5.0.001',
      //   createTime: 1588830235000,
      //   children: [
      //     { name: 'ASD', productType: 'S_CMS', createTime: 1588830235000, status: 0 },
      //     { name: 'ACD', productType: 'B_DMS', createTime: 1588830235000, status: 1 },
      //     { name: 'AED', productType: 'E_EMS', createTime: 1588830235000, status: 2 }
      //   ]
      // }],
      detailShowList: [
        { name: 'description', value: 'test'},
        { name: 'deliverType', value: '222222'},
        { name: 'createTime', value: '2020-05-23 10:00:10'},
        { name: 'pkgVersion', value: 'tetst'},
      ],
      detailInfo: {
        serviceName: ''
      }
    };
  },
  methods: {
    query5GCDetailInfo(param) {
      // D项目查询已部署服务信息
      console.log('D项目查询已部署服务信息', param);
      if (param) {
        this.detailShowList = [
          { name: this.$t('DeployManagement.neName'), value: param.name},
          { name: this.$t('DeployManagement.description'), value: param.description},
          { name: this.$t('DeployManagement.deliverTypeStr'), value: param.deliverTypeStr},
          { name: this.$t('DeployManagement.createTime'), value: new Date(param.createTime).Format('yyyy-MM-dd HH:mm:ss')},
          { name: this.$t('DeployManagement.pkgVersion'), value: param.pkgVersion},
        ];
        this.detailInfo.serviceName = param.serviceName;
      }
      const params = {
        environmentId: param.envID,
        serviceId: param.k8sNodeId
      };
      const url = '/lte/ems/deployedD/queryOne';
      this.$axios.post(url, params).then((res) => {
        const resultVal = res.data.resultVal;
        const array = [];
        console.log("resultVal.k8sService=", resultVal.k8sService);
        // this.setNameAndCalculate(resultVal);
        const temp = { name: resultVal.serviceName,id: param.k8sNodeId, status: resultVal.status, children: resultVal.k8sService, message: resultVal.message };
        this.setNameAndCalculate(resultVal);
        // const temp = { name: resultVal.serviceName,id: param.k8sNodeId, status: resultVal.status,
        //   children: [{name:'12323',children:[{name:'23432432432', children:[{name:'33333333333'}]}]}] };
        // array.push(resultVal.k8sService);
        array.push(temp);
        this.data = array;
      });
    },
    //遍历数据---没有name的对象，将pid设置成name
    setNameAndCalculate(resultVal = []) {
      if(resultVal && resultVal.k8sService) {
        resultVal.k8sService.forEach(item => {
          this.iraterChildren(item)
        })
      }
    },
    iraterChildren(array=[]) {
      if(array.children.length > 0) {
        array.children.forEach(item=> {
          if (item.name === undefined){
            item.name = item.pid;
          }else{
            this.iraterChildren(item)
          }
        })
      }
    }
  }
};
</script>

<style scoped>
  .h-dialogContainer-dp{
    height:100%;width:100%;
  }

</style>
